import script from "./GroupsListView.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupsListView.vue?vue&type=script&setup=true&lang=ts"

import "./GroupsListView.vue?vue&type=style&index=0&id=56e28b6f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56e28b6f"]])

export default __exports__